import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// --- CORE SERVICES IMAGE IMPORTS ---
import corporateImg from '../assets/images/corporate-security.png';
import conciergeImg from '../assets/images/concierge.jpg';
import mobilePatrolImg from '../assets/images/mobile-patrols.png';
import keyHoldingImg from '../assets/images/key-holding.png';

// --- SECTORS IMAGE IMPORTS ---
import sectorCorporateImg from '../assets/images/sector-corporate.jpeg';
import sectorStudentImg from '../assets/images/sector-student.jpeg';
import sectorIndustrialImg from '../assets/images/sector-industrial.jpeg';
import sectorEventsImg from '../assets/images/sector-events.jpg';
import receptionHeroImg from '../assets/images/reception-security-hero.png';

import bannerImg from '../assets/images/banner.png';

// --- BLOG IMAGE IMPORTS (FROM ASSETS/IMAGES) ---
import securityServicesImg from '../assets/images/security-services.png';
import monitorAdaptImg from '../assets/images/monitor and adapt.jpg';

// --- ACCREDITATION LOGO IMPORTS ---
import acclaimLogo from '../assets/accreditationlogos/Acclaim-accreditation-logo.png';
import acsLogo from '../assets/accreditationlogos/ACS-logo.png';
import armedForcesLogo from '../assets/accreditationlogos/Armed-Forces-Covenant-logo.png';
import bicscLogo from '../assets/accreditationlogos/BICSc-logo.png';
import constructionLineLogo from '../assets/accreditationlogos/Construction-line-gold-member-logo.png';
import disabilityConfidentLogo from '../assets/accreditationlogos/Disability-confident-logo.png';
import investorsInPeopleLogo from '../assets/accreditationlogos/Investors-in-people-logo.png';
import iso9001Logo from '../assets/accreditationlogos/ISO-9001-logo.png';
import iso14001Logo from '../assets/accreditationlogos/ISO-14001-logo.png';
import iso45001Logo from '../assets/accreditationlogos/ISO-45001-logo.png';
import nasduLogo from '../assets/accreditationlogos/NASDU-logo.png';
import risqsLogo from '../assets/accreditationlogos/RISQS-logo.png';
import safeContractorLogo from '../assets/accreditationlogos/Safe-contractor-logo.png';

const Home = () => {
  const accreditationLogos = [
    { src: acclaimLogo, alt: "Acclaim Accreditation" },
    { src: acsLogo, alt: "ACS" },
    { src: armedForcesLogo, alt: "Armed Forces Covenant" },
    { src: bicscLogo, alt: "BICSc" },
    { src: constructionLineLogo, alt: "Construction Line Gold" },
    { src: disabilityConfidentLogo, alt: "Disability Confident" },
    { src: investorsInPeopleLogo, alt: "Investors in People" },
    { src: iso9001Logo, alt: "ISO 9001" },
    { src: iso14001Logo, alt: "ISO 14001" },
    { src: iso45001Logo, alt: "ISO 45001" },
    { src: nasduLogo, alt: "NASDU" },
    { src: risqsLogo, alt: "RISQS" },
    { src: safeContractorLogo, alt: "Safe Contractor" }
  ];

  const [startIndex, setStartIndex] = useState(0);
  const logosToShow = 5; 

  const handleNextLogos = () => {
    setStartIndex((prevIndex) => 
      (prevIndex + logosToShow) >= accreditationLogos.length ? 0 : prevIndex + logosToShow
    );
  };

  const handlePrevLogos = () => {
    setStartIndex((prevIndex) => 
      (prevIndex - logosToShow) < 0 ? Math.max(0, accreditationLogos.length - logosToShow) : prevIndex - logosToShow
    );
  };

  const visibleLogos = accreditationLogos.slice(startIndex, startIndex + logosToShow);

  return (
    <div className="home-page">
      
      {/* 1. HERO SECTION */}
      <section className="hero-section">
        <style>
          {`
            .hero-text-content::after { display: none !important; }

            .stat-card-no-hover:hover {
              transform: none !important;
              border-bottom-color: var(--color-secondary-light) !important;
              box-shadow: 0 10px 30px rgba(0,0,0,0.05) !important;
            }
            .stat-card-no-hover:hover .stat-label { color: var(--color-secondary-grey) !important; }
            .stat-card-no-hover:hover::before { background-color: var(--color-secondary-light) !important; box-shadow: none !important; }

            .sector-card-no-hover { transition: none !important; }
            .sector-card-no-hover:hover { transform: none !important; box-shadow: 0 10px 30px rgba(0,0,0,0.1) !important; }
            .sector-card-no-hover .sector-bg { transition: none !important; }
            .sector-card-no-hover:hover .sector-bg { transform: scale(1) !important; }

            /* Default desktop nowrap */
            .hero-nowrap { white-space: nowrap; }

            /* --- PREMIUM MOBILE RESPONSIVE FIXES --- */
            @media (max-width: 992px) {
              .mobile-grid-override { grid-template-columns: repeat(2, 1fr) !important; }
            }
            @media (max-width: 768px) {
              /* Remove the text stretch on mobile */
              .hero-nowrap { white-space: normal; } 

              /* FIX 1: Increase padding to prevent header overlap */
              .hero-section { padding: 13rem 1.5rem 5rem 1.5rem !important; } 
              
              .hero-text-content h1 { font-size: 2.4rem !important; line-height: 1.2 !important; }
              .hero-text-content h2 { font-size: 1.5rem !important; margin-top: 1rem !important; }
              .hero-text-content p { font-size: 1rem !important; }
              
              .vip-text-column { padding-top: 2rem !important; }
              .overlap-experience-card { margin-top: 0 !important; padding: 2rem !important; }
              
              /* Ensure global containers have boundaries */
              .container { padding-left: 1.5rem !important; padding-right: 1.5rem !important; }

              /* Add vertical breathing room to grids */
              .mobile-grid-override { grid-template-columns: 1fr !important; gap: 2rem !important; }
              
              .services-grid-section { padding-bottom: 3rem !important; }
              
              /* FIX 3: Strictly enforce padding on the industries section so cards don't touch edges */
              .industries-section { padding: 3rem 0 4rem 0 !important; }
              .industries-section .container { 
                padding-left: 2rem !important; 
                padding-right: 2rem !important; 
                overflow: hidden;
              }

              .stats-section { padding: 4rem 0 !important; }
              .accreditation-carousel-section { padding: 2rem 0 !important; }

              .sleek-cta-text { min-width: 100% !important; }
            }
          `}
        </style>
        <div className="container hero-container">
          <div className="hero-text-content" style={{ maxWidth: '1000px', position: 'relative', zIndex: 2 }}>
            <h1>
              Trusted Security,<br />
              <span className="hero-nowrap">Delivered with Intelligence</span>
            </h1>
            <h2>Security that thinks ahead</h2>
            <p style={{ maxWidth: '650px', fontSize: 'var(--fs-body)' }}>
              Nightmark Protective Services safeguards people, assets and environments through intelligence-led security and disciplined operational delivery. Our teams work in partnership with the organisations we support, anticipating risk and maintaining safe, controlled environments across every site we protect.
            </p>
            <Link 
              to="/services" 
              className="btn btn-pill" 
              style={{ 
                backgroundColor: 'var(--color-white)', 
                color: 'var(--color-primary-navy)', 
                fontWeight: '800',
                boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
                marginTop: '1.5rem'
              }}
            >
              View Our Services
            </Link>
          </div>
        </div>
      </section>

      {/* 2. SPECIALIZED VIP SERVICES & OVERLAP CARD SECTION */}
      <section className="vip-services-section">
        <div className="container vip-layout-grid">
          <div className="vip-text-column">
            <h2>Specialist Security</h2>
            <p style={{ fontSize: 'var(--fs-body)' }}>
              Effective security is about more than responding to incidents. It is about creating safe, well-managed environments that allow organisations to operate with confidence.
            </p>
            <p style={{ fontSize: 'var(--fs-body)' }}>
              Acting as an extension of your team, our corporate security officers support workplaces, retail destinations and commercial environments through professional security services tailored to the unique requirements of each location. By combining operational vigilance, customer service and proactive risk awareness, we protect people, property and business operations while maintaining a welcoming and professional environment.
            </p>
          </div>
          <div className="overlap-experience-card">
            <h3>Security That Supports Your Business</h3>
            <div className="card-image-box" style={{ backgroundImage: `url(${receptionHeroImg})`, backgroundSize: 'cover', backgroundPosition: 'center', borderRadius: '4px' }}></div>
            <p style={{ fontSize: 'var(--fs-body)' }}>
              Whether providing corporate guarding, concierge security, keyholding or alarm response services, our teams become part of your operation. By combining customer service, operational awareness and proactive security, we create environments that are secure, welcoming and professionally managed.
            </p>
          </div>
        </div>
      </section>

      {/* 3. CORE SERVICES GRID */}
      <section className="services-grid-section container" style={{ paddingBottom: '6rem' }}>
        <div className="mobile-grid-override" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '1.5rem', alignItems: 'stretch' }}>
          
          <Link to="/services/corporate-security" className="service-card-modern" style={{ display: 'flex', flexDirection: 'column', textDecoration: 'none', color: 'inherit' }}>
            <div style={{ height: '220px', borderRadius: '12px', overflow: 'hidden', position: 'relative', marginBottom: '1.5rem', boxShadow: '0 10px 20px rgba(0,0,0,0.1)' }}>
              <div style={{ height: '100%', width: '100%', backgroundImage: `url(${corporateImg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
              <div style={{ position: 'absolute', bottom: 0, width: '100%', padding: '1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', background: 'linear-gradient(transparent, rgba(23, 44, 79, 0.95))' }}>
                <h3 style={{ color: 'var(--color-white)', margin: 0, fontSize: 'var(--fs-h3)', lineHeight: '1.2' }}>Corporate<br />Security</h3>
              </div>
            </div>
            <p style={{ fontSize: 'var(--fs-body)', color: 'var(--color-secondary-grey)', lineHeight: 'var(--lh-body)', margin: 0 }}>
              Our corporate security teams protect workplaces, offices and commercial environments through professional, intelligence-led security.
            </p>
          </Link>

          <Link to="/services/concierge" className="service-card-modern" style={{ display: 'flex', flexDirection: 'column', textDecoration: 'none', color: 'inherit' }}>
            <div style={{ height: '220px', borderRadius: '12px', overflow: 'hidden', position: 'relative', marginBottom: '1.5rem', boxShadow: '0 10px 20px rgba(0,0,0,0.1)' }}>
              <div style={{ height: '100%', width: '100%', backgroundImage: `url(${conciergeImg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
              <div style={{ position: 'absolute', bottom: 0, width: '100%', padding: '1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', background: 'linear-gradient(transparent, rgba(23, 44, 79, 0.95))' }}>
                <h3 style={{ color: 'var(--color-white)', margin: 0, fontSize: 'var(--fs-h3)', lineHeight: '1.2' }}>Concierge<br />Services</h3>
              </div>
            </div>
            <p style={{ fontSize: 'var(--fs-body)', color: 'var(--color-secondary-grey)', lineHeight: 'var(--lh-body)', margin: 0 }}>
              More than a reception presence, our concierge teams act as ambassadors for the environments they support, creating safe and welcoming spaces.
            </p>
          </Link>

          <Link to="/services/mobile-patrols" className="service-card-modern" style={{ display: 'flex', flexDirection: 'column', textDecoration: 'none', color: 'inherit' }}>
            <div style={{ height: '220px', borderRadius: '12px', overflow: 'hidden', position: 'relative', marginBottom: '1.5rem', boxShadow: '0 10px 20px rgba(0,0,0,0.1)' }}>
              <div style={{ height: '100%', width: '100%', backgroundImage: `url(${mobilePatrolImg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
              <div style={{ position: 'absolute', bottom: 0, width: '100%', padding: '1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', background: 'linear-gradient(transparent, rgba(23, 44, 79, 0.95))' }}>
                <h3 style={{ color: 'var(--color-white)', margin: 0, fontSize: 'var(--fs-h3)', lineHeight: '1.2' }}>Mobile<br />Patrols</h3>
              </div>
            </div>
            <p style={{ fontSize: 'var(--fs-body)', color: 'var(--color-secondary-grey)', lineHeight: 'var(--lh-body)', margin: 0 }}>
              Flexible security coverage across multiple sites. Through scheduled and responsive patrols, our teams deter unwanted activity and identify risks early.
            </p>
          </Link>

          <Link to="/services/key-holding" className="service-card-modern" style={{ display: 'flex', flexDirection: 'column', textDecoration: 'none', color: 'inherit' }}>
            <div style={{ height: '220px', borderRadius: '12px', overflow: 'hidden', position: 'relative', marginBottom: '1.5rem', boxShadow: '0 10px 20px rgba(0,0,0,0.1)' }}>
              <div style={{ height: '100%', width: '100%', backgroundImage: `url(${keyHoldingImg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
              <div style={{ position: 'absolute', bottom: 0, width: '100%', padding: '1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', background: 'linear-gradient(transparent, rgba(23, 44, 79, 0.95))' }}>
                <h3 style={{ color: 'var(--color-white)', margin: 0, fontSize: 'var(--fs-h3)', lineHeight: '1.2' }}>Key Holding<br />& Response</h3>
              </div>
            </div>
            <p style={{ fontSize: 'var(--fs-body)', color: 'var(--color-secondary-grey)', lineHeight: 'var(--lh-body)', margin: 0 }}>
              Our trained security officers attend sites, assess situations safely and take appropriate action, reducing disruption and protecting your premises.
            </p>
          </Link>

        </div>
      </section>

      {/* 4. COMMAND-CENTER STATS SECTION */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-header-text text-center">
            <h2>Security Solutions Built Around People</h2>
            <p className="stats-description" style={{ fontSize: 'var(--fs-body)' }}>
              Providing trusted security services that protect what matters most whilst supporting the day-to-day needs of your organisation.
            </p>
          </div>

          <div className="stats-command-grid">
            <div className="stat-card-premium stat-card-no-hover">
              <span className="stat-number">ACS</span>
              <span className="stat-number">Approved</span>
            </div>
            <div className="stat-card-premium stat-card-no-hover">
              <span className="stat-number">24/7</span>
              <span className="stat-number">Helpdesk</span>
            </div>
            <div className="stat-card-premium stat-card-no-hover">
              <span className="stat-number">Strategic</span>
              <span className="stat-number">Consultants</span>
            </div>
            <div className="stat-card-premium stat-card-no-hover">
              <span className="stat-number">24/7</span>
              <span className="stat-number">SOC</span>
            </div>
            <div className="stat-card-premium stat-card-no-hover">
              <span className="stat-number">National</span>
              <span className="stat-number">Coverage</span>
            </div>
          </div>
        </div>
      </section>

      {/* 5. SLEEK FLOATING CTA BANNER */}
      <section className="cta-split-bg-wrapper">
        <div className="container">
          <div 
            className="sleek-cta-banner"
            style={{ backgroundImage: `linear-gradient(to right, rgba(23, 44, 79, 0.95), rgba(23, 44, 79, 0.8)), url(${bannerImg})` }}
          >
            <div className="sleek-cta-text">
              <h2>Professional Security Management</h2>
              <p style={{ fontSize: 'var(--fs-body)' }}>
                Discover how our intelligence-led approach can protect your operations.
              </p>
            </div>
            <div className="sleek-cta-action">
              <Link to="/contact" className="btn btn-pill" style={{ 
                backgroundColor: 'var(--color-white)', color: 'var(--color-primary-navy)', 
                fontWeight: '700', padding: '1rem 2.5rem', fontSize: '0.95rem', boxShadow: '0 8px 20px rgba(0,0,0,0.1)'
              }}>
                Contact us
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 6. INDUSTRIES WE PROTECT */}
      <section className="industries-section" style={{ padding: '4rem 0 6rem 0' }}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: '4rem' }}>
            <h2>Sectors We Protect</h2>
            <p style={{ maxWidth: '700px', margin: '0 auto', fontSize: 'var(--fs-body)' }}>
              We deploy specialised security protocols tailored to the unique risk profiles of the UK industries.
            </p>
          </div>
          
          <div className="team-grid mobile-grid-override" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '1.5rem' }}>
            <div className="sector-card sector-card-no-hover">
              <div className="sector-bg" style={{ backgroundImage: `url(${sectorCorporateImg})` }}></div>
              <div style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', padding: '2rem', background: 'linear-gradient(transparent, rgba(23, 44, 79, 0.95))', color: 'white', textAlign: 'left' }}>
                <h3 style={{ color: 'var(--color-white)', marginBottom: '0.5rem', fontSize: 'var(--fs-h3)' }}>Corporate &<br/>Commercial</h3>
                <p style={{ color: 'var(--color-secondary-light)', fontSize: 'var(--fs-body)', marginBottom: 0, lineHeight: 'var(--lh-body)' }}>Protecting headquarters, staff and critical business infrastructure.</p>
              </div>
            </div>

            <div className="sector-card sector-card-no-hover">
              <div className="sector-bg" style={{ backgroundImage: `url(${sectorStudentImg})` }}></div>
              <div style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', padding: '2rem', background: 'linear-gradient(transparent, rgba(23, 44, 79, 0.95))', color: 'white', textAlign: 'left' }}>
                <h3 style={{ color: 'var(--color-white)', marginBottom: '0.5rem', fontSize: 'var(--fs-h3)' }}>Student<br/>Accommodation</h3>
                <p style={{ color: 'var(--color-secondary-light)', fontSize: 'var(--fs-body)', marginBottom: 0, lineHeight: 'var(--lh-body)' }}>Concierge services offering a controlled but importantly nurturing presence.</p>
              </div>
            </div>

            <div className="sector-card sector-card-no-hover">
              <div className="sector-bg" style={{ backgroundImage: `url(${sectorIndustrialImg})` }}></div>
              <div style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', padding: '2rem', background: 'linear-gradient(transparent, rgba(23, 44, 79, 0.95))', color: 'white', textAlign: 'left' }}>
                <h3 style={{ color: 'var(--color-white)', marginBottom: '0.5rem', fontSize: 'var(--fs-h3)' }}>Construction &<br/>Infrastructure</h3>
                <p style={{ color: 'var(--color-secondary-light)', fontSize: 'var(--fs-body)', marginBottom: 0, lineHeight: 'var(--lh-body)' }}>Robust asset protection and access control for high-risk sites.</p>
              </div>
            </div>

            <div className="sector-card sector-card-no-hover">
              <div className="sector-bg" style={{ backgroundImage: `url(${sectorEventsImg})` }}></div>
              <div style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', padding: '2rem', background: 'linear-gradient(transparent, rgba(23, 44, 79, 0.95))', color: 'white', textAlign: 'left' }}>
                <h3 style={{ color: 'var(--color-white)', marginBottom: '0.5rem', fontSize: 'var(--fs-h3)' }}>Public &<br/>Events</h3>
                <p style={{ color: 'var(--color-secondary-light)', fontSize: 'var(--fs-body)', marginBottom: 0, lineHeight: 'var(--lh-body)' }}>Crowd management and proactive risk mitigation for large gatherings.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 7. RECENT BLOGS SECTION */}
      <section className="recent-blogs-section bg-white text-center" style={{ padding: '6rem 0' }}>
        <div className="container blogs-container">
          <div className="blog-section-header" style={{ marginBottom: '4rem' }}>
            <h2>Read Recent Blog Posts</h2>
            <p style={{ fontSize: 'var(--fs-body)', lineHeight: 'var(--lh-body)', color: 'var(--color-secondary-grey)', margin: '0' }}>
              Explore expert analysis, industry trends and strategic advice.
            </p>
          </div>
          
          <div className="blog-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '3rem', maxWidth: '1200px', margin: '0 auto' }}>
            
            <article className="blog-card-wrapper" style={{ display: 'flex', flexDirection: 'column', height: '100%', borderRadius: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.05)', backgroundColor: 'var(--color-light)', overflow: 'hidden' }}>
              <div className="blog-card-image" style={{ backgroundImage: `url(${securityServicesImg})`, backgroundSize: 'cover', backgroundPosition: 'center', minHeight: '250px' }}></div>
              <div className="blog-card-text-block text-left" style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, padding: '2.5rem' }}>
                <span className="news-category" style={{ fontSize: 'var(--fs-small)', fontWeight: '700', color: 'var(--color-secondary-grey)', textTransform: 'uppercase', letterSpacing: '1px', display: 'block', marginBottom: '0.5rem' }}>
                  Strategic Insight
                </span>
                <h3 style={{ marginTop: '0', fontSize: 'var(--fs-h3)', color: 'var(--color-primary-navy)' }}>
                  Security Is More Than Guards & Gates
                </h3>
                <p style={{ fontSize: 'var(--fs-body)', lineHeight: 'var(--lh-body)', color: 'var(--color-secondary-grey)', flexGrow: 1, marginBottom: '0' }}>
                  Modern security sits at the intersection of people, operations, risk management and organisational resilience.
                </p>
                <div className="blog-card-meta" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '2rem', paddingTop: '1.5rem', borderTop: '1px solid rgba(0,0,0,0.1)' }}>
                  <span className="blog-date" style={{ fontWeight: '600', fontSize: 'var(--fs-small)', color: 'var(--color-secondary-grey)' }}>14 | MAR | 2026</span>
                  <Link to="/news/security-more-than-guards-and-gates" className="btn btn-pill" style={{ backgroundColor: 'var(--color-primary-navy)', color: 'var(--color-white)', padding: '0.6rem 1.5rem', fontSize: 'var(--fs-small)', fontWeight: '700' }}>
                    Read Article
                  </Link>
                </div>
              </div>
            </article>

            <article className="blog-card-wrapper" style={{ display: 'flex', flexDirection: 'column', height: '100%', borderRadius: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.05)', backgroundColor: 'var(--color-light)', overflow: 'hidden' }}>
              <div className="blog-card-image" style={{ backgroundImage: `url(${monitorAdaptImg})`, backgroundSize: 'cover', backgroundPosition: 'center', minHeight: '250px' }}></div>
              <div className="blog-card-text-block text-left" style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, padding: '2.5rem' }}>
                <span className="news-category" style={{ fontSize: 'var(--fs-small)', fontWeight: '700', color: 'var(--color-secondary-grey)', textTransform: 'uppercase', letterSpacing: '1px', display: 'block', marginBottom: '0.5rem' }}>
                  Operational Excellence
                </span>
                <h3 style={{ marginTop: '0', fontSize: 'var(--fs-h3)', color: 'var(--color-primary-navy)' }}>
                  Why Operational Intelligence Matters
                </h3>
                <p style={{ fontSize: 'var(--fs-body)', lineHeight: 'var(--lh-body)', color: 'var(--color-secondary-grey)', flexGrow: 1, marginBottom: '0' }}>
                  Transforming data into informed decision-making to help organisations move beyond merely reacting to incidents.
                </p>
                <div className="blog-card-meta" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '2rem', paddingTop: '1.5rem', borderTop: '1px solid rgba(0,0,0,0.1)' }}>
                  <span className="blog-date" style={{ fontWeight: '600', fontSize: 'var(--fs-small)', color: 'var(--color-secondary-grey)' }}>28 | FEB | 2026</span>
                  <Link to="/news/why-operational-intelligence-matters" className="btn btn-pill" style={{ backgroundColor: 'var(--color-primary-navy)', color: 'var(--color-white)', padding: '0.6rem 1.5rem', fontSize: 'var(--fs-small)', fontWeight: '700' }}>
                    Read Article
                  </Link>
                </div>
              </div>
            </article>

            <article className="blog-card-wrapper" style={{ display: 'flex', flexDirection: 'column', height: '100%', borderRadius: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.05)', backgroundColor: 'var(--color-light)', overflow: 'hidden' }}>
              <div className="blog-card-image" style={{ backgroundImage: `url(${sectorEventsImg})`, backgroundSize: 'cover', backgroundPosition: 'center', minHeight: '250px' }}></div>
              <div className="blog-card-text-block text-left" style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, padding: '2.5rem' }}>
                <span className="news-category" style={{ fontSize: 'var(--fs-small)', fontWeight: '700', color: 'var(--color-secondary-grey)', textTransform: 'uppercase', letterSpacing: '1px', display: 'block', marginBottom: '0.5rem' }}>
                  Corporate Culture
                </span>
                <h3 style={{ marginTop: '0', fontSize: 'var(--fs-h3)', color: 'var(--color-primary-navy)' }}>
                  Why a Diverse Workforce Makes Security Stronger
                </h3>
                <p style={{ fontSize: 'var(--fs-body)', lineHeight: 'var(--lh-body)', color: 'var(--color-secondary-grey)', flexGrow: 1, marginBottom: '0' }}>
                  No matter how advanced technology becomes, effective security still relies on communication, judgement, and cultural awareness.
                </p>
                <div className="blog-card-meta" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '2rem', paddingTop: '1.5rem', borderTop: '1px solid rgba(0,0,0,0.1)' }}>
                  <span className="blog-date" style={{ fontWeight: '600', fontSize: 'var(--fs-small)', color: 'var(--color-secondary-grey)' }}>10 | MAR | 2026</span>
                  <Link to="/news/why-diverse-workforce-makes-security-stronger" className="btn btn-pill" style={{ backgroundColor: 'var(--color-primary-navy)', color: 'var(--color-white)', padding: '0.6rem 1.5rem', fontSize: 'var(--fs-small)', fontWeight: '700' }}>
                    Read Article
                  </Link>
                </div>
              </div>
            </article>

          </div>
          
          <div className="blog-controls" style={{ marginTop: '4rem', display: 'flex', justifyContent: 'center' }}>
            <Link to="/news" className="btn btn-pill" style={{ backgroundColor: 'var(--color-primary-navy)', color: 'var(--color-white)', padding: '1rem 3rem', fontSize: 'var(--fs-body)', fontWeight: '700' }}>
              View All Insights
            </Link>
          </div>
        </div>
      </section>

      {/* 8. ACCREDITATION CAROUSEL STRIP */}
      <section className="accreditation-carousel-section" style={{ backgroundColor: 'var(--color-white)', padding: '4rem 0', borderTop: '1px solid rgba(0,0,0,0.05)' }}>
        <div className="container">
          <div className="accreditation-interactive-wrapper" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '2rem' }}>
            
            <button 
              className="control-btn prev-btn" 
              onClick={handlePrevLogos} 
              aria-label="Previous Logos"
              style={{ backgroundColor: 'var(--color-light)', border: 'none', width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'var(--color-primary-navy)', fontSize: '1.5rem', fontWeight: 'bold' }}
            >
              ‹
            </button>

            <div className="accreditation-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '2rem', width: '100%', alignItems: 'center', justifyItems: 'center' }}>
              {visibleLogos.map((logo, index) => (
                <div className="accreditation-slide-static" key={index}>
                  <img 
                    src={logo.src} 
                    alt={logo.alt} 
                    style={{ maxHeight: '70px', objectFit: 'contain' }}
                  />
                </div>
              ))}
            </div>

            <button 
              className="control-btn next-btn" 
              onClick={handleNextLogos} 
              aria-label="Next Logos"
              style={{ backgroundColor: 'var(--color-light)', border: 'none', width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'var(--color-primary-navy)', fontSize: '1.5rem', fontWeight: 'bold' }}
            >
              ›
            </button>

          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;